import conversationMessageTypes from '../constants/conversation-message-types';

export function convertToToInputFormat(recipients) {

  const formatted = [];

  for (let recipient of recipients) {

    formatted.push({
      email: recipient.fromEmailAddress,
      fullName: recipient.fromName
    });

  }

  return formatted;

}

export function convertToRecipientFormat(objects) {

  const recipients = [];

  for (let object of objects) {

    recipients.push({
      fromEmailAddress: object.email
    });

  }

  return recipients;

}

function removeRecipient(recipients, recipient) {

  const recipientsLength = recipients.length;

  for (let index = 0; index < recipientsLength; index++) {

    const _recipient = recipients[index];

    if (_recipient.fromEmailAddress === recipient.fromEmailAddress) {
      recipients.splice(index, 1);
      break;
    }

  }

  return recipients;

}

export function determineRecipients(conversation, message) {

  const recipients = [];

  if (message.type === conversationMessageTypes.INBOUND) {
    recipients.push(message.sender);
    recipients.push(...removeRecipient([...message.recipients || []], conversation.initialReceiver));
  } else {
    recipients.push(...removeRecipient([...message.recipients || []], conversation.initialReceiver));
  }

  return recipients;

}

export function throttle(fn = () => {}, milliseconds = 0) {

  let lastCalledAt = null;

  return function wrapper(...parameters) {

    if (lastCalledAt === null || Date.now() > (lastCalledAt + milliseconds)) {
      lastCalledAt = Date.now();
      fn(...parameters);
    }

  };

}